// Typelizer digest 20c1008052f8a4f68e0a8df8d414f864
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /educators/teachers/:teacher_id/profile/edit */
  edit: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/profile/edit', params, options),
    method: 'get',
  }),

  /** PATCH /educators/teachers/:teacher_id/profile */
  update: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/profile', params, options),
    method: 'patch',
  }),
}
